import React from 'react';
import { useDragLayer } from 'react-dnd';
import { PreviewWrapper, PreviewItem } from './styles';
import { TYPES } from '../../constants';
import { Image } from '../../card-sort-items/card-sort-item/styles';

const CustomDragLayer = () => {
  const {
    item,
    isDragging,
    currentOffset,
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getClientOffset(),
  }));

  if (!isDragging || !currentOffset || !item) return null;

  if (item.type !== TYPES.CARD_SORT_ITEM) {
    return null;
  }

  return (
    <PreviewWrapper
      style={{
        transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`,
      }}
    >
      <PreviewItem isDragging={false}>
        {item?.name}
        {item?.imageUrl && (
          <Image
            src={item?.imageUrl}
            alt={item?.name}
          />
        )}
      </PreviewItem>
    </PreviewWrapper>
  );
};

export default CustomDragLayer;
